import {
  getDaysTillGoalDate,
  getDefaultGoalPaceKg,
  getDefaultGoalPaceLbs,
  getGolaPaceKgValues,
  getGolaPaceLbsValues,
  getLocalizedDateLabel,
  isWeightGain,
  getSuggestedWeight,
  isApplovinVariant
} from "../helpers"

export default (commonView) =>
  ({ 
    nextStepPath, 
    formFields, 
    redirectIfWeightGainUrl, 
    fasterProgressDays,
    fasterProgressAnimationProps
  }) => ({
    ...commonView({
      nextStepPath,
      formFields,
      redirectIfWeightGainUrl,
    }),

    goalPaceKgValuesMap: getGolaPaceKgValues(),
    goalPaceLbsValuesMap: getGolaPaceLbsValues(),
    defaultGoalPaceKg: getDefaultGoalPaceKg(),
    defaultGoalPaceLbs: getDefaultGoalPaceLbs(),
    initContentHidden: true,
    goalDateLabelTitle: null,
    goalDateLabelTitleClass: "",
    goalDateLabel: null,

    init() {
      this.commonInit()

      this.formValues.goalPaceKg = this.store.values.goalPaceKg || this.defaultGoalPaceKg
      this.formValues.goalPaceLbs = this.store.values.goalPaceLbs || this.defaultGoalPaceLbs

      if (fasterProgressDays) {
        this.runDatesAnimation(fasterProgressDays)
      }
    },

    handleInput($event) {
      this.formValues.goalPaceKg = this.goalPaceKgValuesMap[Number($event.target.value)]
      this.formValues.goalPaceLbs = this.goalPaceLbsValuesMap[Number($event.target.value)]
    },

    getGoalDateLabel(isIncludeYear, isLongMonth) {
      const isMetric = this.isMetric()
      // Use already stored used data
      const { weightKg, weightLbs, targetWeightKg, targetWeightLbs } = this.store.values
      // Use dynamic form data for UI
      const { goalPaceKg, goalPaceLbs } = this.formValues

      const daysTillGoalDate = getDaysTillGoalDate(
        {
          weightKg,
          weightLbs,
          targetWeightKg,
          targetWeightLbs,
          goalPaceKg,
          goalPaceLbs,
        },
        isMetric,
      )

      const goalDate = new Date()
      goalDate.setDate(goalDate.getDate() + daysTillGoalDate)

      return getLocalizedDateLabel(goalDate, isIncludeYear, isLongMonth)
    },

    isWeightGain() {
      return isWeightGain(this.store.values, this.isMetric())
    },

    // Formula taken from the existing cppv3 o-series
    getSuggestedWeight() {
      return getSuggestedWeight({
        values: this.store.values,
        isMetric: this.isMetric()
      })
    },

    getSuggestedWeightDiff() {
      const { weightKg, weightLbs } = this.store.values

      const currentWeight = this.store.isMetric() ? weightKg : weightLbs
      const { suggestedWeightKg, suggestedWeightLbs } = this.getSuggestedWeight()

      return this.store.isMetric() ? currentWeight - suggestedWeightKg : currentWeight - suggestedWeightLbs
    },

    runDatesAnimation(fasterProgressDays) {
      const isMetric = this.isMetric()
      // Use already stored used data
      const { weightKg, weightLbs, targetWeightKg, targetWeightLbs } = this.store.values
      // Use dynamic form data for UI
      const { goalPaceKg, goalPaceLbs } = this.formValues

      const daysTillGoalDate = getDaysTillGoalDate(
        {
          weightKg,
          weightLbs,
          targetWeightKg,
          targetWeightLbs,
          goalPaceKg,
          goalPaceLbs,
        },
        isMetric,
      )
      // Applovin requirements - per policy, the weight loss should not exceed, 2 pounds/week || 1 kg/week
      const minusDays = isApplovinVariant() && daysTillGoalDate < 30 ? 2 : fasterProgressDays
      let duration = fasterProgressAnimationProps?.duration || 500
      let isLinearAnimation = fasterProgressAnimationProps?.isLinearAnimation
      let daysCount = 0

      // Start from the goal date
      const goalDate = new Date()
      goalDate.setDate(goalDate.getDate() + daysTillGoalDate)

      // Recursive updates per day
      const animationTick = () => {
        if (daysCount <= minusDays) {
          const newGoalDate = new Date(goalDate)
          newGoalDate.setDate(newGoalDate.getDate() - daysCount)

          this.goalDateLabelTitle = getLocalizedDateLabel(newGoalDate, false, true)
          this.goalDateLabel = getLocalizedDateLabel(newGoalDate)

          daysCount++

          requestAnimationFrame(() => {
            this.goalDateLabelTitleClass = "";  // Set a dummy class first
            requestAnimationFrame(() => {
              this.goalDateLabelTitleClass = `pipe-tick-${daysCount}`; // Apply the real class
            });
          });

          // Gradually change the animation duration for nicer UI effect
          if (!isLinearAnimation) {
            duration = duration * Math.log2(2.5)
          }

          setTimeout(animationTick, duration)
        }
      }

      animationTick()
    },
  })
